import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import {
  ArrowIcon,
  ItemDescr,
  ItemIcon,
  ItemText,
  MenuItemContainer,
  MenuItemInnerContainer,
} from './TrlNoAuthMenuItem.styles';

export const TrlNoAuthMenuItem = ({
  icon,
  label,
  handleOnClick,
  hasSubMenuArrow,
  isSubMenuOpen,
}) => (
  <MenuItemContainer onClick={handleOnClick} isSubMenuOpen={isSubMenuOpen}>
    <MenuItemInnerContainer>
      <ItemDescr>
        <ItemIcon icon={icon} />
        <ItemText>
          <FormattedMessage id={label} />
        </ItemText>
      </ItemDescr>
      {hasSubMenuArrow && <ArrowIcon icon={faChevronDown} />}
    </MenuItemInnerContainer>
  </MenuItemContainer>
);

TrlNoAuthMenuItem.propTypes = {
  icon: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  handleOnClick: PropTypes.func.isRequired,
  hasSubMenuArrow: PropTypes.bool,
  isSubMenuOpen: PropTypes.bool,
};
